/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { SEND_REMINDER } from '@pages/PayoutDetailPage/apis/graphql';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/PayoutDetailPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { usePolicyId } from '../../provider';
import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface SendReminderProps {
  paymentStatus: string;
  amount: string;
  comment: string;
  receipt?: any;
}

const lookup = require('country-code-lookup');

export interface ISendReminderPayoutDetailMethods extends IPluginMethodMap {
  getSendReminderPayoutDetailProps(args: SendReminderProps): Promise<any>;
}

export class SendReminderPayoutDetailPlugin implements IAgentPlugin {
  readonly methods: ISendReminderPayoutDetailMethods;

  constructor() {
    this.methods = {
      getSendReminderPayoutDetailProps: this.getProps.bind(this),
    };
  }

  async getProps(args: SendReminderProps) {
    //return await this.getSendReminderPayoutDetail(args);
    return {
      // transaction:transactionPayoutDetailConfig
    };
  }

  private async getSendReminderPayoutDetail(args: any) {
    const { userVid } = usePolicyId();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(SEND_REMINDER, {
          vuid: userVid,
        })
        .toPromise();
      if (res?.data) {
        return res?.data;
      }
    } catch (err: any) {
      console.log(`Sign In user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
